<template>

       <el-form class="form"  :inline="true">
              <slot>

              </slot>
             <el-form-item v-for="(list,i) in filterList" :key="i" v-if="i!=0" :label="list.text+'：'" >
               <el-input v-if="list.type=='text'" v-model.trim="list.value" style="width:170px;" placeholder="请输入"></el-input>
                <el-select    v-if="list.type=='select'||list.type=='radio'" v-model="list.value" :multiple="list.multiple"   placeholder="请选择" style="width:170px;">
                  <el-option
                    v-for="item in list.options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
                  <el-date-picker v-if="list.type=='timer'" style="width:170px;"
                    v-model="list.value"
                    type="date"
                    placeholder="选择日期">
                  </el-date-picker>

                <!-- <el-radio v-if="list.type=='radio'" v-model="list.value" v-for="item in list.options" :label="item.value">{{item.label}}</el-radio> -->

            </el-form-item>
          </el-form>

</template>

<script>
  export default {
    name: "sbs-filter-form",
    props: {
        filterList: {
            type: Array,
            default: [],
        }
    },
    data() {
      return {

      };
    }
  };
</script>

<style scoped >

    .el-form--inline .el-form-item{
      margin-right:40px;
      margin-bottom:0;
    }
</style>
